import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetAbsenceCodes = () => {
    const {
        isFetching: isLoading, data: absenceCodes, error,
    } = useQuery({
        queryKey: ["attendancecodes/absence"],
        queryFn: () => axiosManager.get$("/parent/api/attendancecodes?IsAbsence=true").then((response) => response?.data),
        initialData: [],
        retry: 0,
    });

    const absenceCodesOptions = (absenceCodes || []).map((item) => ({ value: item.id, label: item.name }));

    return {
        isLoading, absenceCodes, error, absenceCodesOptions,
    };
};
